import script from "./category-four.vue?vue&type=script&setup=true&lang=js"
export * from "./category-four.vue?vue&type=script&setup=true&lang=js"

import "./category-four.vue?vue&type=style&index=0&id=78929664&lang=css"

const __exports__ = script;

export default __exports__